import { useEffect } from 'react';
import ToonGallery from '@/components/ToonGallery';

export default function ToonsPage() {
  useEffect(() => {
    document.title = 'MEET THE TOONS — ARC TOONS';
  }, []);

  return <ToonGallery />;
}
